import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{ params?: object, query?: { parentId?: string, search?: string, onlyProvinces?: boolean, onlyDistricts?: boolean, page?: number, limit?: number } }} [option]
 */
export const GetAll = async (option = {}) => {
  const response = await $api.get(Endpoints.Location.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Location.GetById(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params?: object, query?: { parentId?: string, startDate?: string, endDate?: string, employeeId?: string, tagIds?: string, customerTagFilterType?: 'And'|'Or' } }} option
 */
export const ParentLocationsWithCustomerCount = async (option = {}) => {
  const response = await $api.get(
    Endpoints.Location.ParentLocationsWithCustomerCount(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params?: object, query?: object }} option
 */
export const LocationsWithSaleCount = async (option = {}) => {
  const response = await $api.get(
    Endpoints.Location.LocationsWithSaleCount(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params?: object, query?: object }} option
 */
export const LocationsWithPlanCount = async (option = {}) => {
  const response = await $api.get(
    Endpoints.Location.LocationsWithPlanCount(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params?: object, query?: object }} option
 */
export const LocationsWithProductSaleCount = async (option = {}) => {
  const response = await $api.get(
    Endpoints.Location.LocationsWithProductSaleCount(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params?: object, query?: object }} option
 */
export const LocationsWithCategorySaleCount = async (option = {}) => {
  const response = await $api.get(
    Endpoints.Location.LocationsWithCategorySaleCount(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params?: object, query?: object }} option
 */
export const ProductSalesWithLocation = async (option = {}) => {
  const response = await $api.get(
    Endpoints.Location.ProductSalesWithLocation(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params?: object, query?: object }} option
 */
export const ProductCategorySalesWithLocation = async (option = {}) => {
  const response = await $api.get(
    Endpoints.Location.ProductCategorySalesWithLocation(option)
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params?: object, query?: { locationId?: string } }} option
 */
export const RegionsWithEmployees = async (option = {}) => {
  const response = await $api.get(
    Endpoints.Location.RegionsWithEmployees(option)
  );
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  GetById,
  ParentLocationsWithCustomerCount,
  LocationsWithSaleCount,
  LocationsWithPlanCount,
  LocationsWithProductSaleCount,
  LocationsWithCategorySaleCount,
  ProductSalesWithLocation,
  ProductCategorySalesWithLocation,
  RegionsWithEmployees,
};
